module.exports = __webpack_public_path__ + "static/media/ic_esign_otp_myway.c0e6328a.svg";